import { render, staticRenderFns } from "./OrganismIdcCreateNewContract.vue?vue&type=template&id=17539c99&scoped=true&"
import script from "./OrganismIdcCreateNewContract.vue?vue&type=script&lang=js&"
export * from "./OrganismIdcCreateNewContract.vue?vue&type=script&lang=js&"
import style0 from "./OrganismIdcCreateNewContract.vue?vue&type=style&index=0&id=17539c99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17539c99",
  null
  
)

export default component.exports